// extracted by mini-css-extract-plugin
export default {"currency":"currency--71496be4"};